import { styled } from "@mui/system"
import { Box, TextField } from "@mui/material"

export const TextboxWrapper = styled(Box)({
  display: "flex",
  flexDirection: "row",
  paddingRight: "8px",
  alignItems: "center",
  gap: "8px",
  alignSelf: "stretch",
  border: "0"
})

export const StyledTextField = styled(TextField)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  flex: "1 0 0",
  border: "0",
}))
